import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
        padding: 0 0 10px 0;
        width: 100%;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

productImageStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
}

productImageStyles.productImage = {
    image: {
        css: css`
            img {
                height: 100%;
                width: auto;
            }
        `,
    },
    linkWrappingImage: {
        css: css`
            height: auto;
            display: flex;
            justify-content: center;
        `,
    },
    img: {
        css: css`
            height: auto;
            width: auto;
            max-height: 100%;
            max-width: 100%;
        `,
    }
};